import { defineComponent as _defineComponent } from 'vue'
import ListLayout from "@/components_v3/layout/ListLayout.vue";
import DownloadButton from "@/components-UI/buttons/DownloadButton.vue";
import ReloadButton from "@/components-UI/buttons/ReloadButton.vue";
import BaseAutocomplete from "@/components/base/design/BaseAutocomplete.vue";
import { computed, onBeforeMount, ref } from "vue";
import { getEmployeesOffersV2 } from "@/api/offers";
import { IBaseAutocomplete } from "@/types";
import { filterClass } from "@/services/filters/filterClass";
import ReportFilterByDate from "@/components/statistics/extended-report/ReportFilterByDate.vue";
import { downloadExcelFile, showServerError } from "@/utils";
import { getMarkingReport } from "@/api/conversions";
import { FormattedItem } from "@/utils/CellsFromBff";
import { IMarkingReportItem } from "@/api/types/conversions";
import { updateQueryString } from "@/utils/updateQueryString";
import { useRoute } from "vue-router/composables";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import { useMarkings } from "@/services/TablePage/markings";
import { getPreviousDate } from "@/utils/formatDates";


export default /*#__PURE__*/_defineComponent({
  __name: 'MarkingsList',
  setup(__props) {

const { headers } = useMarkings();

const route = useRoute();

onBeforeMount(() => {
    if (route.query.offer_id) {
        offer.value = Number(route.query.offer_id);
    }
    if (route.query.period_from && route.query.period_to) {
        period.value = rangeFilter.select = [route.query.period_from, route.query.period_to];
    }
});

const offer = ref(null);

const getOfferData: IBaseAutocomplete = {
    apiMethod: getEmployeesOffersV2,
    errorText: 'Оффер не найден',
    key: 'search',
    itemValue: 'legacy_id',
    template: (item) => item.legacy_id + ' ' + item.name,
    placeholder: 'Оффер',
    clearable: true,
    externalApiParams: (value) => ({ search: value, fields: 'legacy_id,name' }),
};

const updateOffer = (value: number) => {
    offer.value = value;
    getReport();
};

const period = ref<string[]>([]);

const rangeFilter = new filterClass.Datepicker({
    id: 'date',
    label: 'Период',
    pickerType: 'date',
    select: [],
    range: true,
    isOnlyPlaceholder: true,
    allowedDates: () => ({ start: new Date(getPreviousDate('yyyy-MM-dd', 150)), end: new Date() }),
});

const updatePeriod = () => {
    period.value = rangeFilter.select;
    getReport();
};

const items = ref<FormattedItem<IMarkingReportItem>[]>([]);
const total = ref(0);
const isLoading = ref(false);

const getParams = computed(() => {
    return {
        offer_id: offer.value,
        period_from: period.value[0],
        period_to: period.value[1],
    };
});

const getReport = async () => {
    isLoading.value = true;
    try {
        const params = { ...getParams.value };
        params.columns = headers.map(h => h.value);
        if (params.offer_id && params.period_from && params.period_to) {
            const { data, meta } = await getMarkingReport(params);
            items.value = data;
            total.value = meta?.total! || data.length;
        }
    } catch (e) {
        showServerError(e, 'Не удалось получить отчёт');
    } finally {
        isLoading.value = false;
        const currentQuery = route.query;
        updateQueryString({ ...currentQuery, ...getParams.value });
    }
};

const isExportLoading = ref(false);

const exportReport = async () => {
    try {
        isExportLoading.value = true;
        const params = getParams.value;
        if (params.offer_id && params.period_from && params.period_to) {
            const report = await getMarkingReport(params, true);
            downloadExcelFile(report, 'Отчет по ценам и маркировке', 'csv');
        }
    } catch (e) {
        showServerError(e, 'Не удалось экспортировать отчёт');
    } finally {
        isExportLoading.value = false;
    }
};


return { __sfc: true,headers, route, offer, getOfferData, updateOffer, period, rangeFilter, updatePeriod, items, total, isLoading, getParams, getReport, isExportLoading, exportReport, ListLayout, DownloadButton, ReloadButton, BaseAutocomplete, ReportFilterByDate, BaseTable }
}

})